import { errorDescriptionFromResponse } from '../../utils/error';

export default class CaptureOrEditHighlightController {
  constructor(
    $state,
    $scope,
    $uibModalInstance,
    Broadcast,
    Recording,
    Highlight,
    $q,
    $rootScope,
    $timeout,
    $uibModal,
    toaster,
    ConfirmDialog,
    highlightObj,
    recordingId
  ) {
    'ngInject';
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.ConfirmDialog = ConfirmDialog;
    this.Highlight = Highlight;

    this.limits = $rootScope.ApiConfig.modelFieldLimits('highlight', 'maximum');

    this.cancel = () => $uibModalInstance.dismiss('cancel');

    this.maxMonetizedHighlightTimeS = MAX_MONETIZED_HIGHLIGHT_TIME_S;
    this.broadcastIsMonetized = false;
    this.broadcast = Broadcast.get({ id: $state.params.id }, (b) => {
      this.broadcastIsMonetized = !b.is_private && b.is_ticketed;
    });
    this.recording = Recording.get({ id: recordingId });

    // Highlight is passed via modal `resolve`
    if (highlightObj) {
      this.title = `Edit ${highlightObj.name}`;
      this.highlight = Highlight.get({ id: highlightObj.id, broadcastId: $state.params.id }, () => {
        if (this.highlight.start_segment !== '') {
          this.startSegment = this.highlight.start_segment;
          this.stopSegment = this.highlight.stop_segment;
        } else if (this.highlight.start_seconds !== '') {
          this.startSeconds = this.highlight.start_seconds;
          this.stopSeconds = this.highlight.stop_seconds;
        }
      });
    } else {
      this.title = 'Capture New Highlight';
      this.highlight = {
        name: '',
        description: '',
        start_segment: '',
        stop_segment: '',
        start_seconds: 0,
        stop_seconds: 0,
      };
    }

    this.startSeconds = 0;
    this.stopSeconds = 0;
    this.onChangeBounds = (startSeconds, stopSeconds) => {
      this.startSeconds = Math.ceil(startSeconds);
      this.stopSeconds = Math.floor(stopSeconds);
      this.duration = stopSeconds - startSeconds;
    };

    this.loadingPromises = [
      this.broadcast.$promise,
      this.recording.$promise,
      this.highlight.$promise,
    ];
  }

  showPreviewModal() {
    const { $uibModal, $timeout } = this;

    $uibModal.open({
      template: require('./modal-trim-preview.html'),
      controller: ($scope, $uibModalInstance) => {
        'ngInject';
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        $scope.title = 'Preview Highlight Clip';
        $scope.broadcast = this.broadcast;
        $scope.options = {
          autostart: true,
          // TODO: ticketId = admin_token?
          //ticketId: BROADCAST_TICKET,
          trimSeconds: {
            start: this.startSeconds,
            stop: this.stopSeconds,
          },
        };
      },
    });
  }

  delete() {
    const { Highlight, ConfirmDialog, $state } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Highlight',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to permanently delete this highlight?',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      Highlight.delete(
        { id: this.highlight.id, broadcastId: this.broadcast.id },
        () => {
          this.toaster.pop('warning', 'Successfully deleted highlight');
          this.cancel();
          this.$state.go(
            'events.highlights',
            { id: this.broadcast.id, recording: this.recording.id },
            { reload: true }
          );
        },
        () => alert('Error deleting highlight. Please reload this page and try again.')
      );
    });
  }

  saveChanges() {
    this.isSaving = true;

    let startSeconds = this.startSeconds;
    let stopSeconds = this.stopSeconds;

    let promise;
    if (this.highlight.id) {
      promise = this.Highlight.update(
        { broadcastId: this.broadcast.id, id: this.highlight.id },
        {
          name: this.highlight.name,
          description: this.highlight.description,
          start_segment: '',
          stop_segment: '',
          start_seconds: startSeconds,
          stop_seconds: stopSeconds,
        }
      ).$promise;
    } else {
      promise = this.Highlight.create(
        { broadcastId: this.broadcast.id },
        {
          name: this.highlight.name,
          description: this.highlight.description,
          start_segment: '',
          stop_segment: '',
          start_seconds: startSeconds,
          stop_seconds: stopSeconds,
        }
      ).$promise;
    }

    promise
      .then(() => {
        this.isSaving = false;
        this.toaster.pop('success', 'Successfully created highlight');
        this.cancel();
        this.$state.go(
          'events.highlights',
          { id: this.broadcast.id, recording: this.recording.id },
          { reload: true }
        );
      })
      .catch((error) => {
        console.error(error);
        this.isSaving = false;
        let errorDetails = errorDescriptionFromResponse(error);
        this.toaster.pop('warning', 'Unable to create highlight', errorDetails);
      });
  }
}



// WEBPACK FOOTER //
// ./app/pages/events/modal-capture-highlight-recorded.js